export default {"src":"/_next/static/media/solar_case.275326a8.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};